import dayjs from "dayjs";

const skuInspectionConverter = {
    convertIn: (responseData) => {
        if (responseData.date) {
            responseData.date = dayjs(responseData.date);
        }

        if (responseData.createdAt) {
            responseData.createdAt = dayjs(responseData.createdAt);
        }

        if (responseData.updatedAt) {
            responseData.updatedAt = dayjs(responseData.updatedAt);
        }

        return responseData;
    },
    convertOut: ({ sku, id, createdBy, createdAt, updatedAt, ...rest }) => {
        return {
            ...rest,
            ...(sku?.id && {
                sku: sku.id,
            }),
        };
    },
};

export default skuInspectionConverter;
